/** Helper for ITA photo field in editor-fields. See useMediaFieldAdapter for legacy editor equivalent. */
/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
import {
  PhotoItemValue,
} from '@fulcrumapp/fulcrum-core';
import { Image } from '../media-props';

const castItem = (item: Object): PhotoItemValue => {
  if (!(item instanceof PhotoItemValue)) {
    return new PhotoItemValue(item, { ...item });
  }
  return item;
};

function photoFieldHelper(
  onChange: <T, >(field: Element, value: T) => void,
  images: Array<Image>,
  field: Element,
) {
  return {
    handleCaptionChange: (
      mediaID: string,
      newCaption: string,
    ) => {
      const editedImages = [...images];
      editedImages.forEach((currentImage: Image) => {
        // @ts-ignore
        if (currentImage.photo_id === mediaID) {
          currentImage.caption = newCaption;
        }
      });

      onChange(field, editedImages);
    },

    handleDelete: (
      mediaID: string,
    ) => {
      const imagesKept = images.filter(
        // @ts-ignore
        (currentImage: Image) => currentImage.photo_id !== mediaID,
      );
      onChange(field, imagesKept);
    },

    handleAdd: (
      uploadedFile: File,
    ) => {
      if (uploadedFile) {
        // @ts-ignore
        const newImage = { photo_id: uploadedFile.access_key, caption: null };
        const editedImagesList = [...images];
        editedImagesList.push(newImage as unknown as Image);

        onChange(field, editedImagesList);
      }
    },
  };
}
export {
  photoFieldHelper, castItem,
};
